{
  "reports.title": "تقارير الموارد البشرية",
  "reports.loadError": "معرفناش نحمّل التقرير ده.",
  "reports.export": "نزّل CSV",
  "reports.exportCsv": "صدّر CSV",
  "reports.view.label": "اعرض كـ",
  "reports.view.chart": "رسم بياني",
  "reports.view.table": "جدول",
  "reports.nav.label": "التقارير",
  "reports.nav.headcount": "عدد الموظفين والدوران",
  "reports.nav.attendance": "الحضور",
  "reports.nav.leave": "الإجازات",
  "reports.nav.utilization": "الاستغلال",
  "reports.nav.enps": "eNPS",
  "reports.nav.hiring": "مسار التوظيف",
  "reports.nav.payroll": "تكلفة المرتبات",
  "reports.period.from": "من",
  "reports.period.to": "لحد",
  "reports.period.range": "الفترة (لحد {count} شهر)",
  "reports.period.month": "الشهر",
  "reports.period.previousMonth": "الشهر اللي فات",
  "reports.period.nextMonth": "الشهر اللي جاي",
  "reports.period.year": "السنة",
  "reports.period.yearOption": "{year}",
  "reports.columns.month": "الشهر",
  "reports.columns.person": "الموظف",
  "reports.columns.total": "الإجمالي",
  "reports.headcount.now": "عدد الموظفين حاليًا",
  "reports.headcount.headcount": "عدد الموظفين",
  "reports.headcount.hires": "التعيينات",
  "reports.headcount.leavers": "المغادرين",
  "reports.headcount.turnover": "معدل دوران الموظفين",
  "reports.headcount.averageTurnover": "متوسط الدوران",
  "reports.headcount.chartTitle": "عدد الموظفين كل شهر",
  "reports.headcount.chartDescription": "الموظفين اللي على رأس الشغل آخر يوم في كل شهر.",
  "reports.headcount.tableCaption": "عدد الموظفين والتعيينات والمغادرين ومعدل الدوران كل شهر",
  "reports.headcount.departments": "حسب القسم",
  "reports.headcount.departmentsHint": "في آخر الفترة.",
  "reports.headcount.noDepartment": "من غير قسم",
  "reports.headcount.emptyTitle": "مفيش بيانات للفترة دي",
  "reports.headcount.emptyBody": "افتح سجلات الموظفين بتواريخ التعيين عشان تشوف العدد ومعدل الدوران.",
  "reports.attendance.hint": "أيام العمل الشهر ده: {days, number}. الأيام حسب الحالة لكل اللي حضورهم متسجّل.",
  "reports.attendance.caption": "الحضور لكل موظف",
  "reports.attendance.workdays": "أيام العمل",
  "reports.attendance.present": "حاضر",
  "reports.attendance.remote": "من البيت",
  "reports.attendance.absent": "غياب",
  "reports.attendance.paidLeave": "إجازة مدفوعة",
  "reports.attendance.unpaidLeave": "إجازة غير مدفوعة",
  "reports.attendance.leave": "إجازات",
  "reports.attendance.missingPunch": "بصمة ناقصة",
  "reports.attendance.shortDays": "أيام ناقصة ساعات",
  "reports.attendance.issues": "مخالفات",
  "reports.attendance.workedHours": "ساعات الشغل",
  "reports.attendance.deductionDays": "أيام الخصم",
  "reports.attendance.emptyTitle": "مفيش حضور الشهر ده",
  "reports.attendance.emptyBody": "مفيش حد حضوره متسجّل كان شغال الشهر ده.",
  "reports.leave.chartTitle": "أيام الإجازات في {year}",
  "reports.leave.chartDescription": "الإجازات المعتمدة حسب النوع، محسوبة في الشهر اللي بتبدأ فيه.",
  "reports.leave.caption": "أيام الإجازات حسب النوع والشهر",
  "reports.leave.kind": "نوع الإجازة",
  "reports.leave.days": "الأيام",
  "reports.leave.people": "الأشخاص",
  "reports.leave.emptyTitle": "مفيش إجازات السنة دي",
  "reports.leave.emptyBody": "الإجازات المعتمدة بتظهر هنا حسب النوع والشهر.",
  "reports.utilization.chartTitle": "الاستغلال في {month}",
  "reports.utilization.chartDescription": "وقت الحضور قصاد الوقت المتسجّل على الشغل، والجزء اللي بيتحاسب عليه العميل.",
  "reports.utilization.caption": "الاستغلال لكل موظف",
  "reports.utilization.attended": "حضور",
  "reports.utilization.logged": "متسجّل",
  "reports.utilization.billable": "قابل للفوترة",
  "reports.utilization.attendedHours": "ساعات الحضور",
  "reports.utilization.loggedHours": "ساعات متسجّلة",
  "reports.utilization.billableHours": "ساعات الفوترة",
  "reports.utilization.share": "الاستغلال",
  "reports.utilization.billableShare": "نسبة الفوترة",
  "reports.utilization.hours": "{hours} س",
  "reports.utilization.noTime": "مفيش وقت متسجّل",
  "reports.utilization.emptyTitle": "مفيش وقت متسجّل الشهر ده",
  "reports.utilization.emptyBody": "الاستغلال بيظهر لما الناس تسجّل حضور وتسجّل وقت على الشغل.",
  "reports.enps.chartTitle": "eNPS لكل استبيان",
  "reports.enps.chartDescription": "من −100 لـ +100، من أقدم استبيان. بس الاستبيانات اللي فيها 3 إجابات أو أكتر.",
  "reports.enps.survey": "الاستبيان",
  "reports.enps.responses": "الإجابات",
  "reports.enps.score": "eNPS",
  "reports.enps.emptyTitle": "مفيش eNPS لسه",
  "reports.enps.emptyBody": "اعمل استبيان eNPS، ونتيجته هتظهر هنا من أول 3 إجابات.",
  "reports.hiring.chartTitle": "التقديمات وصلت لحد فين",
  "reports.hiring.chartDescription": "{count, plural, zero {مفيش وظايف في الفترة دي.} one {في وظيفة واحدة، التقديمات اللي اتعملت في الفترة.} two {في وظيفتين، التقديمات اللي اتعملت في الفترة.} few {في # وظايف، التقديمات اللي اتعملت في الفترة.} many {في # وظيفة، التقديمات اللي اتعملت في الفترة.} other {في # وظيفة، التقديمات اللي اتعملت في الفترة.}}",
  "reports.hiring.caption": "مسار التوظيف لكل وظيفة",
  "reports.hiring.opening": "الوظيفة",
  "reports.hiring.applied": "اتقدموا",
  "reports.hiring.screening": "الفرز",
  "reports.hiring.interview": "المقابلة",
  "reports.hiring.assessment": "التقييم",
  "reports.hiring.offer": "العرض",
  "reports.hiring.hired": "اتعيّنوا",
  "reports.hiring.rejected": "اترفضوا",
  "reports.hiring.withdrawn": "انسحبوا",
  "reports.hiring.daysToHire": "أيام لحد التعيين",
  "reports.hiring.emptyTitle": "مفيش تقديمات في الفترة دي",
  "reports.hiring.emptyBody": "التقديمات على وظايفك بتظهر هنا حسب المرحلة.",
  "reports.payroll.chartTitle": "صافي المرتبات كل شهر",
  "reports.payroll.chartDescription": "شهور المرتبات المقفولة بس. المبالغ بالجنيه المصري.",
  "reports.payroll.caption": "تكلفة المرتبات كل شهر، بالجنيه المصري",
  "reports.payroll.people": "الأشخاص",
  "reports.payroll.basic": "الأساسي",
  "reports.payroll.overtime": "الأوفرتايم",
  "reports.payroll.additions": "الإضافات",
  "reports.payroll.deductions": "الخصومات",
  "reports.payroll.net": "الصافي",
  "reports.payroll.thousands": "{amount} ألف",
  "reports.payroll.emptyTitle": "مفيش مرتبات مقفولة في الفترة دي",
  "reports.payroll.emptyBody": "تكلفة المرتبات بتظهر لما مرتبات الشهر تتقفل.",
  "reports.exportExcel": "تصدير لإكسل",
  "reports.exportExcelFailed": "تعذّر تجهيز ملف الإكسل. جرّب تاني.",
  "reports.nav.permissions": "الأذونات",
  "reports.nav.breaks": "الاستراحات",
  "reports.nav.balances": "أرصدة الإجازات",
  "reports.nav.statutory": "الإجازة القانونية",
  "reports.permissions.hint": "الأذونات اللي اتاخدت في الشهر. الوقت اللي فوق المسموح المدفوع بيتخصم.",
  "reports.permissions.caption": "الأذونات لكل شخص",
  "reports.permissions.count": "الأذونات",
  "reports.permissions.time": "الوقت",
  "reports.permissions.overQuota": "فوق الحد",
  "reports.permissions.unpaid": "وقت غير مدفوع",
  "reports.permissions.emptyTitle": "مفيش أذونات الشهر ده",
  "reports.permissions.emptyBody": "الأذونات المعتمدة بتظهر هنا لكل شخص.",
  "reports.breaks.hint": "أيام المخالفة هي الأيام اللي عدّت قاعدة (وقّف الماوس عليها للتفاصيل)، بتتعلّم للمراجعة ومبتتخصمش.",
  "reports.breaks.caption": "الاستراحات لكل شخص",
  "reports.breaks.daysWorked": "أيام الشغل",
  "reports.breaks.total": "وقت الاستراحة",
  "reports.breaks.average": "المتوسط في اليوم",
  "reports.breaks.overrunDays": "فوق المسموح",
  "reports.breaks.longStretchDays": "+٥ ساعات متواصلة",
  "reports.breaks.missingEndDays": "استراحة متقفلتش",
  "reports.breaks.longSpanDays": "يوم طويل",
  "reports.breaks.flaggedDays": "أيام مخالفة",
  "reports.breaks.emptyTitle": "مفيش استراحات الشهر ده",
  "reports.breaks.emptyBody": "الاستراحات بتظهر هنا لما الناس تاخدها على الساعة.",
  "reports.balances.hint": "كل رصيد واقف فين دلوقتي، للسنة اللي اخترتها.",
  "reports.balances.caption": "أرصدة الإجازات لكل شخص في {year}",
  "reports.balances.kindFilter": "نوع الإجازة",
  "reports.balances.allKinds": "كل الأنواع",
  "reports.balances.accrued": "المستحق",
  "reports.balances.granted": "الممنوح",
  "reports.balances.taken": "المأخوذ",
  "reports.balances.pending": "قيد الموافقة",
  "reports.balances.available": "المتبقي",
  "reports.balances.showEmpty": "{count, plural, one {إظهار رصيد فاضي} two {إظهار رصيدين فاضيين} few {إظهار # أرصدة فاضية} many {إظهار # رصيدًا فاضيًا} other {إظهار # رصيد فاضي}}",
  "reports.balances.allEmpty": "كل الأرصدة هنا فاضية.",
  "reports.balances.emptyTitle": "مفيش أرصدة السنة دي",
  "reports.balances.emptyBody": "الأرصدة بتظهر لما يكون للناس ملفات وأنواع إجازات ليها أيام.",
  "reports.statutory.law": "الإجازة السنوية القانونية: ١٥ يوم في السنة، منهم ستة ورا بعض (م. 125).",
  "reports.statutory.hint": "اللي لسه ناقصهم بيظهروا الأول.",
  "reports.statutory.caption": "الإجازة السنوية القانونية في {year}",
  "reports.statutory.entitlement": "الاستحقاق",
  "reports.statutory.requiredDays": "المطلوب",
  "reports.statutory.takenDays": "المأخوذ",
  "reports.statutory.requiredBlock": "المتصل المطلوب",
  "reports.statutory.longestBlock": "أطول متصل",
  "reports.statutory.status": "الحالة",
  "reports.statutory.met": "مكتمل",
  "reports.statutory.notMet": "غير مكتمل",
  "reports.statutory.daysLeft": "{count, plural, one {باقي يوم واحد} two {باقي يومين} few {باقي # أيام} many {باقي # يومًا} other {باقي # يوم}}",
  "reports.statutory.blockLeft": "{count, plural, one {مطلوب يوم ورا بعض} two {مطلوب يومين ورا بعض} few {مطلوب # أيام ورا بعض} many {مطلوب # يومًا ورا بعض} other {مطلوب # يوم ورا بعض}}",
  "reports.statutory.daysShort": "{count, plural, one {ناقص يوم} two {ناقص يومين} few {ناقص # أيام} many {ناقص # يومًا} other {ناقص # يوم}}",
  "reports.statutory.blockShort": "ناقص المتصل",
  "reports.statutory.unmet": "لسه مكملوش",
  "reports.statutory.unmetNone": "الكل كمّل",
  "reports.statutory.ofPeople": "{count, plural, one {من شخص واحد} two {من شخصين} few {من # أشخاص} many {من # شخصًا} other {من # شخص}}",
  "reports.statutory.metCount": "مكملين",
  "reports.statutory.emptyTitle": "مفيش حد نراجعه السنة دي",
  "reports.statutory.emptyBody": "الناس اللي ليهم إجازة سنوية بيظهروا هنا."
}
